<template>
  <pagination
    v-model="pagination.page"
    :records="pagination.total || 0"
    :per-page="pagination.limit"
    :options="options"
    @paginate="$emit('paginate', $event)"
    class="snappy-pagination"
  >
  </pagination>
</template>

<script>
import {Pagination} from 'vue-pagination-2';

export default {
  name: 'snappy-pagination',
  props: {    
    pagination: {
      type: Object,
      required: true,
    },
    hasCount: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Pagination,
  },
  data() {
    return {
      options: {},
    };
  },
  created() {    
    if (!this.hasCount) {
      this.options.texts = {count: ''};
    }
  },
};
</script>

<style lang="scss">
@import '../../sass/web/_variables.scss';
.snappy-pagination {
  a {
    text-decoration: none !important;
  }
  .pagination {
    margin: 0;
  }
}
</style>
